/**
 * Handles the successfull submit of mail form
 * @param mailFormWrapper DOM wrapper of the whole form
 */
export const mailFormHandler = (mailFormWrapper: HTMLElement): void => {
  const wpcf7Elm = mailFormWrapper.querySelector('.wpcf7') as unknown as HTMLElement
  const formElements = wpcf7Elm.querySelectorAll('.row') as unknown as HTMLElement[]
  const formMegaTitle = mailFormWrapper.querySelector('.js-mailForm-megatitle') as unknown as HTMLElement
  const formTitle = mailFormWrapper.querySelector('.js-mailForm-title') as unknown as HTMLElement

  wpcf7Elm.addEventListener('wpcf7submit', (e) => {
    if (formMegaTitle) {
      formMegaTitle.remove()
    }
    formTitle.remove()
    formElements.forEach((element : HTMLElement) => {
      element.remove()
    })
  }, false)
}
